import Loading from "@/components/Loading"
import { HITSEEKER_EVENT } from "@/util/hitseekerEvents"
import { Box } from "@mui/material"
import "moment/locale/ar-sa"
import moment from "moment/moment"
import { lazy, useMemo } from "react"
import ReactGA from "react-ga4"
import { RouterProvider, createBrowserRouter } from "react-router-dom"
import { getCurrentLocale } from "./util/i18n"
import { useAppConfig } from "./providers/ApplicationProvider"

const AppMaintenance = lazy(() => import("@/components/AppMaintenance"))

if (import.meta.env.VITE_ENABLE_GA === "true") {
  ReactGA.initialize(import.meta.env.VITE_GA_MEASUREMENT_ID)
}

if (import.meta.env.VITE_MIXPANEL_TOKEN) {
  HITSEEKER_EVENT.init(import.meta.env.VITE_MIXPANEL_TOKEN, {
    track_pageview: "full-url",
    persistence: "localStorage",
  })
}

export default function App() {
  const { routes, isLoading } = useAppConfig()

  const router = useMemo(() => {
    if (import.meta.env.VITE_SHUTDOWN_APP_FOR_MAINTENANCE === "true") {
      return createBrowserRouter([
        {
          path: "*",
          element: <AppMaintenance />,
        },
      ])
    }

    const locale = getCurrentLocale()
    const routerBasePath = locale ? `/${locale}` : undefined

    moment.locale(locale === "ar-SA" ? "ar-sa" : "en")

    return createBrowserRouter(routes, { basename: routerBasePath })
  }, [routes])

  return isLoading ? (
    <Box height="100vh">
      <Loading />
    </Box>
  ) : (
    <RouterProvider router={router} />
  )
}
